/**
 * Available feature flags that can be enabled/disabled per company
 */
export enum FeatureName {
  PropertyManagement = 'PropertyManagement',
  EquipmentTracking = 'EquipmentTracking',
  MaintenanceSchedules = 'MaintenanceSchedules',
  AdvancedReporting = 'AdvancedReporting',
  APIAccess = 'APIAccess',
  WhiteLabeling = 'WhiteLabeling',
  CustomFields = 'CustomFields',
  BulkOperations = 'BulkOperations'
}

/**
 * Descriptions for each feature flag
 */
export const FEATURE_DESCRIPTIONS: Record<FeatureName, string> = {
  [FeatureName.PropertyManagement]: 'Enable property and unit tracking features',
  [FeatureName.EquipmentTracking]: 'Enable equipment tracking and management',
  [FeatureName.MaintenanceSchedules]: 'Enable scheduled maintenance functionality',
  [FeatureName.AdvancedReporting]: 'Enable advanced reporting and analytics',
  [FeatureName.APIAccess]: 'Enable API access for integrations',
  [FeatureName.WhiteLabeling]: 'Enable white-label customization options',
  [FeatureName.CustomFields]: 'Enable custom field definitions',
  [FeatureName.BulkOperations]: 'Enable bulk operations and batch processing'
};

/**
 * Get all available feature names as an array
 */
export const AVAILABLE_FEATURES = Object.values(FeatureName);

